const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
]

const buildReportDate = (day: number, month: number, year: number) => {
  const date = new Date(Date.UTC(year, month - 1, day))
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    return null
  }

  return `${String(day).padStart(2, "0")}-${MONTHS[month - 1]}-${year}`
}

export const formatReportDate = (value: string | Date | null | undefined) => {
  if (!value) return value || ""
  if (value instanceof Date) {
    return (
      buildReportDate(
        value.getDate(),
        value.getMonth() + 1,
        value.getFullYear()
      ) || String(value)
    )
  }

  const normalized = value.trim()
  const dayFirst = /^(\d{1,2})[/-](\d{1,2})[/-](\d{4})(?:\D.*)?$/.exec(
    normalized
  )
  if (dayFirst) {
    return (
      buildReportDate(
        Number(dayFirst[1]),
        Number(dayFirst[2]),
        Number(dayFirst[3])
      ) || value
    )
  }

  const iso = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[T\s].*)?$/.exec(normalized)
  if (iso) {
    return (
      buildReportDate(Number(iso[3]), Number(iso[2]), Number(iso[1])) || value
    )
  }

  const namedMonth = /^(\d{1,2})-([A-Za-z]{3})-(\d{4})$/.exec(normalized)
  if (namedMonth) {
    const month = MONTHS.findIndex(
      (item) => item.toLowerCase() === namedMonth[2].toLowerCase()
    )
    return month >= 0
      ? buildReportDate(
          Number(namedMonth[1]),
          month + 1,
          Number(namedMonth[3])
        ) || value
      : value
  }

  return value
}

export const isReportDateField = (field: string) => {
  const normalized = field.trim().toLowerCase().replaceAll(" ", "_")
  return (
    normalized === "dob" ||
    normalized.includes("date_of_birth") ||
    normalized.endsWith("_date") ||
    normalized === "date"
  )
}
